import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  checkboxCell: {
    width: theme.spacing(6),
    padding: theme.spacing(0, 0.5),
  },
}))

export default useStyles
